import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HStack, Text, VStack } from '@chakra-ui/react'
import { usePin } from 'context'
import { CREATE_PIN_SCHEMA, PinCreateFormType } from 'context/Pin'
import { Formik } from 'formik'
import { themeColors } from 'theme'

import { CardCustomResult } from 'components/CardCustomResult'
import { CardBody, CardContainer } from 'components/CustomCard'
import { InputControl, SubmitButton } from 'components/InputCustom'
import { CreatePinIcon, InfoIcon } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'

export const CreatePin = () => {
  const navigate = useNavigate()
  const { createPin, checkUserPin, clearError, pinState: { loading, error } } = usePin()
  const { icon: { interrogationIconColor, secondaryIconColor }, text: { missingData } } = themeColors
  const [isResult, setIsResult] = useState(false)

  const initialValues: PinCreateFormType = {
    pin: '',
    confirmPin: '',
  }

  const handleCheck = async () => {
    await checkUserPin(true) && navigate('/my-vehicles')
  }

  useEffect(() => {
    handleCheck()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const handleSubmit = async (data: PinCreateFormType) => {
    const result = await createPin(data)

    setIsResult(result)
  }

  const handleGoBack = () => {
    navigate('/my-vehicles')
  }

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={CREATE_PIN_SCHEMA}>
      {({ isValid }) => (
        <CardContainer
          isScreen
          hiddenStack={!!isResult}
          onClose={handleGoBack}
          headerText={'Crea tu PIN'}>
          <CardBody>
            {!isResult
              ? <VStack justifyContent={'center'} alignItems={'center'} spacing={6}>
                <HStack>
                  <InfoIcon size={7} fill={interrogationIconColor} />
                  <Text color={missingData}>Te recomendamos de crear uno fácil de recordar ya que funciona para
                    bloquear, desbloquear el motor y compartir tu vehículo. </Text>
                </HStack>
                <InputControl
                  inputType='password'
                  inputProps={{ placeholder: 'Ingresar PIN', maxLength: 4 }}
                  name='pin'
                  label='Crear PIN (Debe ser de 4 números)'
                  isDisabled={loading}
                />
                <InputControl
                  inputType='password'
                  inputProps={{ placeholder: 'Confirmar PIN', maxLength: 4 }}
                  name='confirmPin'
                  isDisabled={loading}
                  label='Confirmar PIN' />
                <SubmitButton
                  loadingText={'Creando PIN...'}
                  isLoading={loading}
                  mx={'auto'}
                  leftIcon={<CreatePinIcon size={7} fill={isValid ? secondaryIconColor : interrogationIconColor} />}
                >
                  Crear pin
                </SubmitButton>
              </VStack>
              : <CardCustomResult
                onSubmit={() => handleGoBack()}
                headerTitle={'¡PIN creado con éxito!'} />
            }
          </CardBody>
        </CardContainer>
      )
      }
    </Formik >
  )
}
